//
// FlexibilityType.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var FlexibilityType = {
    FIXED:0,
    GROWABLE:1,
    SHRINKABLE:2,
    FLEXIBLE:3
};
export default FlexibilityType;
